import { module } from 'modujs';
import lottie from 'lottie-web'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.lottie = lottie.loadAnimation({
            autoplay: true,
            container: this.el,
            loop: true,
            path: this.getData('url'),
            renderer: 'svg',
        })
    }
}
